// extracted by mini-css-extract-plugin
module.exports = {"pageText":"PageText_pageText__1yEAv","p3":"PageText_p3__36Hl-"};